//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SfList, SfMenuItem, SfPagination, SfContentPages } from '@storefront-ui/vue';
import { onSSR } from '@vue-storefront/core';
import { ref, useRoute, computed, useRouter } from '@nuxtjs/composition-api';
import { useArtcleList, useArtcleCatList } from '@bee-hole/coms';
import { useCache } from '@bee-hole/cache';

export default {
  name: "ArticleList",
  components: {
    SfList,
    SfMenuItem,
    SfPagination,
    SfContentPages
  },
  layout({ app }) {
    return app?.$storeConfig?.mall_home_type || 'default';
  },
  setup(props, context) {
    const { load, list } = useArtcleList('catArtcleList');
    const { load: loadCat, list: listCat } = useArtcleCatList('catList');
    const router = useRouter();
    const pageNo = ref(1);
    const limit = ref(10);
    const activePage = ref();
    const getCuurentDate = context?.root?.$options?.getCuurentDate;
    const count = computed(() => {
      const val = Math.ceil((list.value?.total_count) / limit.value);
      return (val);
    });
    const route = useRoute();
    const ArticleList = computed(() => list.value?.list);
    const getArticleList = async (id) => {
      const params = {
        page: pageNo.value,
        limit: 10,
        cat_id: id
      };
      return await load(params);
    };

    const { addTags } = useCache();
    onSSR(async () => {
      if (route.value?.query?.page) {
        pageNo.value = Number(route.value.query.page);
      }
      await loadCat();
      await getArticleList(route.value?.params.id);
      activePage.value = listCat.value?.list?.find((item) => item.cat_id === Number(route.value?.params.id))?.name;
      try {
        addTags([
          { prefix: "L", value: route.value?.params.id, dataPrefix: context.root.$options.$storeConfig?.mall_cache_pre }
        ]);
      } catch (e) {
        console.log(e);
      }
    });
    const changeActivePage = async (e) => {
      const id = listCat.value?.list?.find((item) => item.name === e)?.cat_id;
      const localeTransformedPath = context.root.localePath('/l/' + id);
      router.push(localeTransformedPath);
      return false;
      // console.log('activePage', e);
      // activePage.value = e;
      // await getArticleList(id);
    };
    return {
      ArticleList,
      pageNo,
      count,
      getCuurentDate,
      changeActivePage,
      listCat,
      activePage
    };
  }
};
